import { Action } from '@ngrx/store';
import { type } from '../util';

export const ActionTypes = {
  FETCH_AUTOMATION_TEMPLATES:                                             type('[Automations] Fetch Templates'),
  FETCH_AUTOMATION_TEMPLATES_FAILURE:                                     type('[Automations] Fetch Templates Failure'),
  FETCH_AUTOMATION_TEMPLATES_SUCCESS:                                     type('[Automations] Fetch Templates Success'),
  SELECT_AUTOMATION:                                                      type('[Automations] Select CEv2 Automation Template'),
  SELECT_AUTOMATION_SUCCESS:                                              type('[Automations] Fetched Automation Template Details'),
  SELECT_AUTOMATION_FAILURE:                                              type('[Automations] Failed to Fetch Automation Template Details'),
  UPDATE_AUTOMATION_CUSTOMIZATION:                                        type('[Automations] Update Automation Customizations'),
  UPDATE_AUTOMATION_REWARD:                                               type('[Automations] Update Automation Reward'),
  UPDATE_AUTOMATION_AUDIENCE:                                             type('[Automations] Update Automation Audience'),
  UPDATE_IS_AUTOMATED:                                                    type('[Automations] Update Is Automated'),
  CREATE_AUTOMATION:                                                      type('[Automations] Create Automation'),
  CREATE_AUTOMATION_COMPLETE:                                             type('[Automations] Create Automation Completed'),
  UPDATE_AUTOMATION:                                                      type('[Automations] Update Automation'),
  UPDATE_AUTOMATION_COMPLETE:                                             type('[Automations] Update Automation Completed'),
  STOP_AUTOMATION:                                                        type('[Automations] Stop Automation'),
  STOP_AUTOMATION_COMPLETE:                                               type('[Automations] Stop Automation Completed')
};

export class FetchAutomationTemplates implements Action {
  public type = ActionTypes.FETCH_AUTOMATION_TEMPLATES;
  constructor(public payload: any) { }
}

export class FetchAutomationTemplatesSuccess implements Action {
  public type = ActionTypes.FETCH_AUTOMATION_TEMPLATES_SUCCESS;
  constructor(public payload: any[] = []) { }
}

export class FetchAutomationTemplatesFailure implements Action {
  public type = ActionTypes.FETCH_AUTOMATION_TEMPLATES_FAILURE;
  constructor( public payload: any = '') { }
}

export class SelectAutomation implements Action {
  public type = ActionTypes.SELECT_AUTOMATION;
  constructor(public payload: any = {}) { }
}
export class SelectAutomationSuccess implements Action {
  public type = ActionTypes.SELECT_AUTOMATION_SUCCESS;
  constructor(public payload: any = {}) { }
}
export class SelectAutomationFailure implements Action {
  public type = ActionTypes.SELECT_AUTOMATION_FAILURE;
  constructor(public payload: any = {}) { }
}

export class UpdateAutomationCustomizations implements Action {
  public type = ActionTypes.UPDATE_AUTOMATION_CUSTOMIZATION;
  constructor(public payload: any = {}) { }
}

export class UpdateAutomationReward implements Action {
  public type = ActionTypes.UPDATE_AUTOMATION_REWARD;
  constructor(public payload: any = {}) { }
}

export class UpdateAutomationAudience implements Action {
  public type = ActionTypes.UPDATE_AUTOMATION_AUDIENCE;
  constructor(public payload: { count: number; customers: string[] }) { }
}

export class UpdateIsAutomated implements Action {
  public type = ActionTypes.UPDATE_IS_AUTOMATED;
  constructor(public payload: any = {}) { }
}

export class CreateAutomation implements Action {
  public type = ActionTypes.CREATE_AUTOMATION;
}

export class CreateAutomationComplete implements Action {
  public type = ActionTypes.CREATE_AUTOMATION_COMPLETE;
  constructor(public payload: any = {}) { }
}

export class StopAutomation implements Action {
  public type = ActionTypes.STOP_AUTOMATION;
  constructor(public payload: any = {}) { }
}

export class StopAutomationComplete implements Action {
  public type = ActionTypes.STOP_AUTOMATION_COMPLETE;
  constructor(public payload: any, public locationNumber: string) { }
}

export class UpdateAutomation implements Action {
  public type = ActionTypes.UPDATE_AUTOMATION;
}

export class UpdateAutomationComplete implements Action {
  public type = ActionTypes.UPDATE_AUTOMATION_COMPLETE;
  constructor(public payload: any = {}) { }
}

export type Actions =
    | FetchAutomationTemplates
    | FetchAutomationTemplatesSuccess
    | FetchAutomationTemplatesFailure
    | SelectAutomation
    | SelectAutomationSuccess
    | SelectAutomationFailure
    | UpdateAutomationCustomizations
    | UpdateAutomationReward
    | UpdateAutomationAudience
    | UpdateIsAutomated
    | CreateAutomation
    | CreateAutomationComplete
    | UpdateAutomation
    | UpdateAutomationComplete
    | StopAutomation
    | StopAutomationComplete
